import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import {withRouter} from "react-router-dom";

import AssistanceTable from "./AssistanceTable";

class Assistance extends Component {

    render() {
        document.title ="Consulenti | CLTV";

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Consulenti" pageTitle="CLTV"/>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <AssistanceTable />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(Assistance);
